import { useSelector, useDispatch } from "react-redux";

import { setSection, updateSection } from "../../../assignmentSlice";

import { boldText, normalizeQuotes } from "../../../../../utils/textUtils";

import UserInputBar from "../../widgets/UserInputBar";

const EngBlankPage = ({
  pageList,
  currentPage,
  currentIndex,
  userInput,
  selectedBlankIndex,
  setCurrentIndex,
  setUserInput,
  setSelectedBlankIndex,
  setPageList,
  setOverlayVisible,
}) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);

  const handleChange = (e) => {
    setUserInput(e.target.value);
  };

  const changeSelectedBlank = (element) => {
    if (element.isSubmitted) return alert("이미 정답 제출한 빈칸입니다.");
    setSelectedBlankIndex(element.index);
    currentPage.data.question.forEach((question) => {
      if (question.type === "blank") {
        if (question.index === element.index) {
          // isSubmitted가 false이면 input을, true이면 firstAttemptAnswer를 보여줌
          if (currentPage.isSubmitted && question.firstAttemptAnswer) {
            setUserInput(question.firstAttemptAnswer);
          } else {
            setUserInput(question.input);
          }
        }
      }
    });
  };

  const handleSubmit = () => {
    if (currentPage.isSubmitted) return;

    const submitCount = currentPage.submitCount + 1;
    let isAllSubmitted = true;
    let data;

    if (submitCount < 10) {
      data = {
        ...currentPage.data,
        question: currentPage.data.question.map((element) => {
          if (element.type === "blank") {
            const isCorrect = normalizeQuotes(element.input).replace(/[!.,:?]/g, "").toLowerCase() ===
              normalizeQuotes(currentPage.data.answers[element.index])
                .replace(/[!.,:?]/g, "")
                .toLowerCase();
            
            const isFirstAttempt = element.firstAttemptCorrect === undefined;
            
            if (isCorrect) {
              return {
                ...element,
                isSubmitted: true,
                input: currentPage.data.answers[element.index],
                firstAttemptCorrect: isFirstAttempt ? true : element.firstAttemptCorrect,
                firstAttemptAnswer: isFirstAttempt ? element.input : element.firstAttemptAnswer,
              };
            } else {
              isAllSubmitted = false;
              return { 
                ...element, 
                input: "",
                firstAttemptCorrect: isFirstAttempt ? false : element.firstAttemptCorrect,
                firstAttemptAnswer: isFirstAttempt ? element.input : element.firstAttemptAnswer,
              };
            }
          }
          return element;
        }),
      };
    } else {
      data = {
        ...currentPage.data,
        question: currentPage.data.question.map((element) => {
          if (element.type === "blank") {
            return {
              ...element,
              isSubmitted: true,
              input: currentPage.data.answers[element.index],
              firstAttemptCorrect: element.firstAttemptCorrect,
              firstAttemptAnswer: element.firstAttemptAnswer,
            };
          }
          return element;
        }),
      };
    }

    const newPageList = pageList.map((prevPage, index) => {
      if (index === currentIndex) {
        return {
          ...prevPage,
          data: data,
          isSubmitted: isAllSubmitted,
          submitCount: submitCount,
        };
      }
      return prevPage;
    });

    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
    dispatch(
      updateSection({ sectionId: section.id, data: { answer: newPageList } })
    );

    if (isAllSubmitted) {
      setSelectedBlankIndex(-1);
    } else {
      const notSubmittedElement = data.question.find(
        (element) => element.type === "blank" && element.isSubmitted === false
      );
      changeSelectedBlank(notSubmittedElement);
    }

    if (submitCount < 10) {
      setOverlayVisible(true);
      setTimeout(() => {
        setOverlayVisible(false);
        if (isAllSubmitted && currentIndex < pageList.length - 1) {
          setTimeout(() => {
            setCurrentIndex(currentIndex + 1);
            setUserInput("");
          }, 200);
        }
      }, 600);
    } else {
      alert(
        "제출 횟수를 초과하였습니다. 정답을 확인하고, 다음 문제로 넘어가세요."
      );
    }
  };

  const handleSetAnswer = () => {
    const nextElement = currentPage.data.question
      .filter(
        (element) => element.type === "blank" && element.isSubmitted === false
      )
      .find((element) => element.index > selectedBlankIndex);
    if (nextElement) {
      changeSelectedBlank(nextElement);
    }

    const newPageList = pageList.map((prevPage, index) => {
      if (index === currentIndex) {
        return {
          ...prevPage,
          data: {
            ...prevPage.data,
            question: prevPage.data.question.map((element) => {
              if (element.type === "blank") {
                if (element.index === selectedBlankIndex) {
                  return { ...element, input: userInput };
                }
              }
              return element;
            }),
          },
        };
      }
      return prevPage;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "30px",
      }}
    >
      <div style={{ fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "14px" : "20px", fontWeight: 700, textAlign: "center" }}>빈칸을 채우세요.</div>
      <div
        style={{
          fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "17px" : "28px",
          textAlign: "center", // [v8] 문장 가운데
        }}
      >
        {currentPage.type !== "" &&
          currentPage.data.question.map((element, index) => {
            if (element.type === "text") {
              return element.content;
            } else if (element.type === "blank") {
              const userAnswer = element.input;
              const blankLength = element.length;
              const isSelected = element.index === selectedBlankIndex;

              return (
                <span
                  key={"eng_blank_" + index}
                  onClick={() => changeSelectedBlank(element)}
                  style={{
                    display: "inline-block",
                    minWidth: 20,
                    marginRight: 4,
                    marginLeft: 4,
                    padding: "0 4px",
                    cursor: "pointer",
                    letterSpacing: userAnswer === "" ? "0" : null,
                    // ECHO 시안 13 — 활성 빈칸: teal 밑줄 + teal-mist / 그 외: ink-25 밑줄
                    borderBottom: isSelected
                      ? "1.5px solid #00D9C0"
                      : "1.5px solid #B9C1C9",
                    borderRadius: "6px 6px 0 0",
                    backgroundColor: isSelected ? "#F2FAF8" : "transparent",
                  }}
                >
                  {userAnswer || "\u00A0".repeat(blankLength)}
                </span>
              );
            }
            return null;
          })}
      </div>
      <div
        style={{
          fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "13px" : "20px", // [문장테스트 v5] 해석 축소
          color: "#7A8490",
        }}
      >
        {boldText({ text: currentPage.data.kor || currentPage.data.eng })}
      </div>
      <div style={{ position: "relative", width: Math.min(window.innerWidth, window.screen.width) <= 768 ? "92%" : "60%", marginTop: Math.min(window.innerWidth, window.screen.width) <= 768 ? "22px" : "50px", marginBottom: Math.min(window.innerWidth, window.screen.width) <= 768 ? "48px" : 0 }}>
        <UserInputBar
          handleSetAnswer={handleSetAnswer}
          handleChange={handleChange}
          userInput={
            currentPage.isSubmitted && selectedBlankIndex >= 0
              ? currentPage.data.question.find(q => q.type === "blank" && q.index === selectedBlankIndex)?.firstAttemptAnswer || userInput
              : userInput
          }
          disabled={currentPage.isSubmitted}
          type={"analysis"}
        />
      </div>
      <button
        style={{
          // [제출 인라인] 모바일은 흐름 속 배치(둥둥 제거), PC는 기존 위치
          position: Math.min(window.innerWidth, window.screen.width) <= 768 ? "static" : "absolute",
          alignSelf: Math.min(window.innerWidth, window.screen.width) <= 768 ? "flex-end" : undefined,
          marginTop: Math.min(window.innerWidth, window.screen.width) <= 768 ? "18px" : 0,
          bottom: "90px", // 최하단으로부터 10px 떨어짐
          right: "60px", // 우측으로부터 10px 떨어짐
          padding: Math.min(window.innerWidth, window.screen.width) <= 768 ? "8px 22px" : "10px 32px", // [제출 v2]
          backgroundColor: currentPage.isSubmitted ? "#E6EDEC" : "#0E141B", // ECHO cur-submit
          color: currentPage.isSubmitted === true ? "#7A8490" : "white",
          border: "none",
          fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "14px" : "16px",
          fontWeight: 700,
          borderRadius: "999px",
          cursor: "pointer",
        }}
        onClick={() => handleSubmit()}
      >
        제출하기
      </button>
    </div>
  );
};

export default EngBlankPage;
